import { Dispatch, Store } from "redux";
import { TActionRequest } from "../../base/types/redux";
import MiddlewareRegistry from "../../base/redux/MiddlewareRegistry";
import { LoginRequest, ForgotPasswordRequest } from "../utils/types";
import { apiLogin, apiForgotPassword } from "./services";
import { ACTION_TYPES } from "./actionTypes";
import { setLoginState, setUserInfo, setForgotPasswordState, setUserInfoRemember } from "./actions";
import { message } from 'antd';

export const middleware =
  ({ dispatch, getState }: Store) =>
  (next: Function) =>
  async (action: TActionRequest<any>) => {
    next(action);
    switch (action.type) {
      case ACTION_TYPES.LOGIN: {
        return await handleLogin(dispatch, action, getState);
      }
      case ACTION_TYPES.FORGOT_PASSWORD: {
        return await handleForgotPassword(dispatch, action, getState);
      }
    }
  };

MiddlewareRegistry.register(middleware);

const handleLogin = async (
  dispatch: Dispatch,
  action: TActionRequest<LoginRequest>,
  getState: () => {  }
) => {
  try {
    const response = await apiLogin(action.params!);
    if (response?.status?.code === "A200") {
      dispatch(setUserInfo(response));
      dispatch(setLoginState({ isFetching: false, isSuccess: true, data: response.data }));
      localStorage.setItem("user_info", JSON.stringify(response?.data));
      localStorage.setItem("access_token", response?.data?.jwt?.access_token);
      if (action?.params?.remember) {
        sessionStorage.setItem("login_info", JSON.stringify(action.params));
      } else {
        sessionStorage.removeItem("login_info");
      }
    }
  } catch (err: any) {
    message.error(err.response?.data.status.message);
    dispatch(setLoginState({ isFetching: false, isSuccess: false, data: err }));
  }
};

const handleForgotPassword = async (
  dispatch: Dispatch,
  action: TActionRequest<ForgotPasswordRequest>,
  getState: () => {  }
) => {
  try {
    dispatch(setForgotPasswordState({ isFetching: true, isSuccess: false, data: null }));
    const response = await apiForgotPassword(action.params!);
    if (response?.status?.code === "A200") {
      message.success(response?.status?.message);
      dispatch(setForgotPasswordState({ isFetching: false, isSuccess: true, data: response.data }));
    }
  } catch (err: any) {
    message.error(err.response?.data.status.message);
    dispatch(setForgotPasswordState({ isFetching: false, isSuccess: false, data: err }));
  }
};